import React from 'react'
import EmailLogo from '../assets/email-logo.png';

export default function EmailIcon(props) {

	return ( <img src={EmailLogo} height="25px" { ...props}/> );
}